import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import { PRODUCT_MODEL_TYPES, PRODUCT_MODEL_LABEL_MESSAGES } from './productModelConstants';

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 13px;
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  white-space: nowrap;
  background-color: #E3F2FD;
  color: #1565C0;
`;

const ProductModelPill = ({ productModel }) => {
  if (productModel === PRODUCT_MODEL_TYPES.NONE) {
    return <span>—</span>;
  }

  const message = PRODUCT_MODEL_LABEL_MESSAGES[productModel];

  return (
    <Pill>
      {intl.formatMessage(message)}
    </Pill>
  );
};

ProductModelPill.propTypes = {
  productModel: PropTypes.oneOf(Object.values(PRODUCT_MODEL_TYPES)).isRequired,
};

export default ProductModelPill;
